import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UiService } from "@services/ui.service";
import { LicenceCount } from "../../../shared/models/classes/Dashboard/licence/licence-count";
import { TestResult } from "../../../shared/models/classes/Dashboard/test-result";
import { DashboardBizzDevService } from "../../../shared/services/dashboard-bizz-dev.service";

@Component({
    selector: "app-kpis",
    templateUrl: "./kpis.component.html",
    styleUrls: ["./kpis.component.scss"],
})
export class KpisComponent implements OnInit {
    bbcDate: Date;
    bbcNbrOfDays: number;
    testResult: TestResult;
    errorNumber: number;
    usersConnexion: string;
    licenceCount: LicenceCount;
    expiredLicences: number;
    openTicketNumber: number;

    constructor(
        private dashboardService: DashboardBizzDevService,
        private uiSrv: UiService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.getBBCImportDate();
        this.getTestResults();
        this.getErrorLog();
        this.getLicenceNumber();
        this.getUsersConnexionNumber();
        this.getExpiredLicences();
        this.getOpenTicketNumber();
    }

    getOpenTicketNumber() {
        this.dashboardService.getOpenTicketNumber().subscribe((value) => {
            this.openTicketNumber = value;
        });
    }
    getLicenceNumber() {
        this.dashboardService.GetNumberLicence().subscribe((value) => {
            this.licenceCount = value;
        });
    }
    getErrorLog() {
        this.dashboardService.getErrorNumber().subscribe((value) => {
            this.errorNumber = value;
        });
    }
    getTestResults() {
        this.dashboardService
            .getTest()
            .subscribe((value) => (this.testResult = value));
    }
    getBBCImportDate() {
        this.dashboardService
            .getProviderImportDate("bbc2020")
            .subscribe((value) => {
                this.bbcDate = value;
                this.bbcNbrOfDays = this.getDayCountToNow(this.bbcDate);
            });
    }
    getUsersConnexionNumber() {
        this.dashboardService.getUsersConnexionNumber().subscribe((value) => {
            this.usersConnexion =
                this.uiSrv.translate('dashboardBizzDev.overview.kpis.leftPanel.connexionNumber.fullLabel')
                    .replace("{count}", value.count.toString())
                    .replace("{start}", value.startDate)
                    .replace("{end}", value.endDate);
        });
    }
    getExpiredLicences() {
        this.dashboardService.getExpiredLicences().subscribe((value) => {
            this.expiredLicences = value;
        });
    }

    getDayCountToNow(start: Date) {
    const now = new Date();
    const intervalMillisecond = now.getTime() - new Date(start).getTime();
    return intervalMillisecond / (24 * 60 * 60 * 1000);
}

    loadPage(path: string, frag: string) {
        this.router
            .navigate([path], { fragment: frag })
            .then((success) => console.log("navigation success?", success))
            .catch(console.error);
    }
}
